import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getFormattedDateFromIsoDate,
  getFolderUrl,
  iconTypesForLatestUploads,
} from '../../utils/v4/utils';
import { loadContentItems } from '../../actions/contentItemActions';
import urlHelper from '../../utils/urlHelper';
import { getPermissions } from '../../utils/getPermissions';
import AssetImage from '../Assets/AssetImage';

export function LatestUploads(props) {
  const {
    contentItems = {},
    signs: {
      signs: { signs },
    },
  } = props;
  const { contentItems: queriedContentItem = {} } = contentItems;
  const { content_items: queriedContentItems = [] } = queriedContentItem;
  const { loadContentItems } = props;
  const { prepareDeleteFunction } = props;

  useEffect(() => {
    loadContentItems('?parent=/*&sort=createdDate+desc&count=10');
  }, []);

  const mergeData = items => {
    const {
      auth,
      sequences: {
        sequences: { sequences },
      },
      playlists: {
        playlists: { playlists },
      },
    } = props;
    const p = getPermissions(auth);

    if (!sequences || !playlists) {
      return items;
    }

    let mergedItems = items.map(item => {
      if (item.type === 'sequence') {
        const sequence = sequences.find(seq => +seq.id === +item.content_id);

        if (sequence) {
          item.sequenceEntries = sequence.sequenceEntries;
        }
      }

      if (item.type === 'playlist') {
        const playlist = playlists.find(pl => +pl.id === +item.content_id);

        if (playlist) {
          item.playlistEntries = playlist.playlistEntries;
        }
      }

      return item;
    });

    mergedItems = mergedItems.filter(item => {
      // exclude some items from Lite tier
      if (!p.atLeastTierPro && ['folder', 'image', 'sign', 'campaign'].includes(item.type)) {
        return false;
      }

      return true;
    });

    return mergedItems;
  };

  const onLatestUploadItemClick = item => {
    const { history } = props;
    const url = item.type === 'folder' ? getFolderUrl(item, props) : urlHelper.getContentUrl(item);

    history.push(url.replace('home', 'content'));
  };

  const contentItemsToDisplay = mergeData(queriedContentItems);

  return (
    <div className=" h-[358px] overflow-y-auto w-full border- border-2 bg-white rounded-[12px]">
      <div className="flex justify-center">
        <div className=" w-[97%]">
          <p className="poppins-bold font-700 text-[16px] mt-2  text-dark-night">Latest</p>
        </div>
      </div>

      <div className="flex flex-col w-full items-center" data-test="latest-uploads-list">
        {contentItemsToDisplay.slice(0, 6).map(content => {
          return (
            <div
              key={content.id}
              className="flex space-x-2 w-[97%] mt-2 border-b-[0.5px] items-center pb-[4px] cursor-pointer"
              onClick={() => onLatestUploadItemClick(content)}
            >
              <div className="w-[120px] flex items-center justify-center">
                <AssetImage
                  id={content.content_id}
                  type={content.type}
                  item={content}
                  signs={signs}
                />
              </div>

              <div className=" flex-1 overflow-hidden">
                <p
                  aria-label="content name"
                  className="text-[#00243E] truncate font-[700] poppins-extrabold text-[12px] mb-[2px]"
                >
                  {content.name}
                </p>
                <p
                  aria-label="content created date"
                  className="text-[#00243E] font-[400] poppins-regular text-[12px] mb-0 "
                >
                  {getFormattedDateFromIsoDate(content.createdDate)}
                </p>
              </div>

              <div className="flex items-center justify-center">
                {iconTypesForLatestUploads[content.type] && (
                  <img
                    data-test={`content-type-icon-${content.id}`}
                    src={iconTypesForLatestUploads[content.type]}
                    alt={`${content.type} icon`}
                    className="w-[28px] h-[28px]"
                  />
                )}
              </div>

              <div className=" w-[169px] th-hidden md:!flex md:flex-col ">
                <p className="text-[#00243E] font-[400] poppins-regular text-[12px]  overflow-hidden truncate">
                  {content.parent}
                </p>
                {content.tags?.some(t => t.length > 0) && (
                  <div aria-label="content tags" className="flex flex-wrap gap-1">
                    {content.tags
                      .filter(t => t.length > 0)
                      .map(tag => (
                        <span
                          key={tag}
                          className="inline-flex items-center rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-sunrise inset-ring inset-ring-orange-600/20"
                        >
                          {tag}
                        </span>
                      ))}
                  </div>
                )}
              </div>

              <div className="flex space-x-2">
                <button
                  type="button"
                  onClick={e => {
                    e.stopPropagation();
                    onLatestUploadItemClick(content);
                  }}
                >
                  <img
                    src="/assets/images/icons/edit.svg"
                    alt="edit icon"
                    className="w-[34px] h-[34px] cursor-pointer duration-500 hover:scale-105"
                  />
                </button>

                <button
                  type="button"
                  data-test={`delete-latest-upload-item-${content.id}`}
                  onClick={e => {
                    e.stopPropagation();
                    prepareDeleteFunction({
                      title: 'Delete Item',
                      subtitle: 'Are you sure you want to delete this item? ',
                      content,
                    });
                  }}
                >
                  <img
                    src="/assets/images/icons/remove_file.svg"
                    alt="remove file icon"
                    className="w-[34px] h-[34px] cursor-pointer duration-500 hover:scale-105"
                  />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

LatestUploads.propTypes = {
  history: PropTypes.object,
  contentItems: PropTypes.object.isRequired,
  loadContentItems: PropTypes.func.isRequired,
  prepareDeleteFunction: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  sequences: PropTypes.object.isRequired,
  playlists: PropTypes.object.isRequired,
  signs: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  contentItems: state.contentItems,
  auth: state.auth,
  sequences: state.sequences,
  playlists: state.playlists,
  signs: state.signs,
});
const mapDispatchToProps = {
  loadContentItems,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LatestUploads));
